var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.75H10.7773L8.89062 0.982422C8.42188 0.513281 7.78906 0.25 7.125 0.25H2.5C1.11914 0.25 0 1.36953 0 2.75V15.25C0 16.6305 1.11914 17.75 2.5 17.75H17.5C18.8809 17.75 20 16.6305 20 15.25V5.25C20 3.87109 18.9141 2.75 17.5 2.75ZM18.125 15.25C18.125 15.5947 17.8446 15.875 17.5 15.875H2.5C2.15539 15.875 1.875 15.5947 1.875 15.25V2.75C1.875 2.40531 2.15539 2.125 2.5 2.125H7.08984C7.25676 2.125 7.41379 2.19 7.53164 2.30813L10 4.625H17.5C17.8446 4.625 18.125 4.90531 18.125 5.25V15.25Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderRegular);
export default __webpack_public_path__ + "static/media/folder-regular.446eb94452eaf333be44af4ad046e2d0.svg";
export { ForwardRef as ReactComponent };